package com.gstechnovos.sanative.components.widgets.styles

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.px

// 1. Define the interactive button style
val MaintenanceButtonStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Color.rgb(0x008080)) // Classic Teal
            .color(Colors.White)
            .minHeight(56.px)
            .padding(leftRight = 32.px, topBottom = 16.px)
            .borderRadius(12.px)
            .fontWeight(FontWeight.SemiBold)
            .textDecorationLine(TextDecorationLine.None)
            .boxShadow(0.px, 4.px, 12.px, 0.px, Color.rgb(0x008080).copyf(alpha = 0.3f))
            .display(DisplayStyle.InlineBlock)
            // CSS transition for a smooth animation
            .styleModifier { property("transition", "all 0.2s ease-in-out") }
    }
    // 2. Hover Effect: Button lifts slightly and darkens
    hover {
        Modifier
            .backgroundColor(Color.rgb(0x006666)) // Darker teal
            .boxShadow(0.px, 6.px, 16.px, 0.px, Color.rgb(0x008080).copyf(alpha = 0.4f))
            .styleModifier { property("transform", "translateY(-2px)") } // Lifts up
    }
    // 3. Click (Active) Effect: Button presses down and goes darkest
    active {
        Modifier
            .backgroundColor(Color.rgb(0x004D4D)) // Deepest teal
            .boxShadow(0.px, 2.px, 8.px, 0.px, Color.rgb(0x008080).copyf(alpha = 0.2f))
            .styleModifier { property("transform", "translateY(0px)") } // Pushes down
    }
}